import { isParkPlusWebView } from "core-lib/utils/source";
import { useRouter } from "next/router";
import Script from "next/script";

function AnalyticsScripts(props) {
  const router = useRouter();
  return (
    <>
      {process.env.ENV === "production" && (
        <>
          <Script
            src="https://www.googletagmanager.com/gtag/js?id=G-5MKXNVV7F6"
            strategy="afterInteractive"
          ></Script>
          <Script id="google-analytics" strategy="afterInteractive">
            {`
            window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'G-5MKXNVV7F6');`}
          </Script>

          <Script id="new-relic" strategy="afterInteractive">
            {`
              ;window.NREUM||(NREUM={});NREUM.init={distributed_tracing:{enabled:true},privacy:{cookies_enabled:true},ajax:{deny_list:["bam.nr-data.net"]},logging:{enabled:false}};
          ;NREUM.loader_config={accountID:"4727287",trustKey:"4727287",agentID:"601556102",licenseKey:"NRJS-5135d76d8591213414b",applicationID:"601556102"};
          ;NREUM.info={beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"NRJS-5135d76d8591213414b",applicationID:"601556102",sa:1};
            `}
          </Script>
          <Script
            src="https://js-agent.newrelic.com/nr-loader-spa-1.290.1.min.js"
            strategy="afterInteractive"
          ></Script>

          <Script id="gtm" strategy="afterInteractive">
            {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); 
            })(window,document,'script','dataLayer','GTM-WB6JX5X')`}
          </Script>
          {!isParkPlusWebView() &&
            router.basePath !== "/app/parkplus-money" && (
              <Script id="moengage" strategy="afterInteractive">
                {`!(function(e,n,i,t,a,r,o,d){var s=e[a]=e[a]||[];if(s.invoked=0,s.initialised>0||s.invoked>0)return console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1;e.moengage_object=a;var l={},g=function n(i){return function(){for(var n=arguments.length,t=Array(n),a=0;a<n;a++)t[a]=arguments[a];(e.moengage_q=e.moengage_q||[]).push({f:i,a:t})}},u=["track_event","add_user_attribute","add_first_name","add_last_name","add_email","add_mobile","add_user_name","add_gender","add_birthday","destroy_session","add_unique_user_id","moe_events","call_web_push","track","location_type_attribute"],m={onsite:["getData","registerCallback"]};for(var c in u)l[u[c]]=g(u[c]);for(var v in m)for(var f in m[v])null==l[v]&&(l[v]={}),l[v][m[v][f]]=g(v+"."+m[v][f]);r=n.createElement(i),o=n.getElementsByTagName("head")[0],r.async=1,r.src=t,o.appendChild(r),e.moe=e.moe||function(){return(s.invoked=s.invoked+1,s.invoked>1)?(console.error("MoEngage Web SDK initialised multiple times. Please integrate the Web SDK only once!"),!1):(d=arguments.length<=0?void 0:arguments[0],l)},r.addEventListener("load",function(){if(d)return e[a]=e.moe(d),e[a].initialised=e[a].initialised+1||1,!0}),r.addEventListener("error",function(){return console.error("Moengage Web SDK loading failed."),!1})}(window,document,"script","https://cdn.moengage.com/webpush/moe_webSdk.min.latest.js","Moengage"))
              Moengage = moe({
              app_id: 'PBFZRI8T24I1KX22KDVSZJZ1',
              debug_logs: '0'
              });`}
              </Script>
            )}
        </>
      )}
    </>
  );
}

export default AnalyticsScripts;
